const todayName = (date) => {
    const weekDays = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
    const dayNumber = new Date(date).getDay()
    const dayName = weekDays[dayNumber]

    return dayName
}

export default todayName